import axios from "./AxiosWrapper";
const overrideHeader = "x-override-location";
const LocationService = {
  setOverrideLocation(location) {
    axios.defaults.headers.common[overrideHeader] = location.toUpperCase();
    axios.defaults.headers.post[overrideHeader] = location.toUpperCase();
  }
};
export default LocationService;
